import { render } from "./ProductReturnRow.vue?vue&type=template&id=40b7eb69"
import script from "./ProductReturnRow.vue?vue&type=script&lang=js"
export * from "./ProductReturnRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__